import { useState } from 'react'
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

import { postCompanySettings } from '../../../MyApi/sb/settings';

import AddSettings from '../../../Components/sb/settings'
import PageHeader from '../../../Components/UI/PageHeader'



const Settings = () => {
    const initialData = {
        attendance_types: [], 
        identity_types: [],
        allow: true, 
      };
    const [attendanceType ,setAttendanceType] =useState([])
    const [identity_type ,setIdentifyType]=useState([])
    const [allow,setAllow] =useState(1)
    const [attendances , setAttendances]=useState(initialData)


 const mutation = useMutation("postCompanySettings",(postData)=>postCompanySettings(postData), {
 onSuccess:(data)=>{
    toast.success(`${data.message}`)
 },
 onError:(error)=>{
   toast.error(`${error.response.data.message}`)
 }
 })

 const handelPostRequest=()=>{
    mutation.mutate({attendances})
 }

    const isDiabled =()=>{
   return !(identity_type &&attendanceType)
    } 
    return (
        <div>
      <PageHeader  title="settings" handlePostRequest={handelPostRequest} isLoading={mutation.isLoading}  saveButton={true}  isdisbled={isDiabled} />
      <AddSettings allow={allow} attendances={attendances} identity_type={identity_type}  setAttendances={setAttendances} attendanceType={attendanceType}    setAttendanceType={setAttendanceType} setIdentifyType={setIdentifyType} setAllow={setAllow} />
        </div>

    )
  }
  
  export default Settings